import axios from "axios";
const BaseURL = process.env.REACT_APP_BASE_URL

const login = (form) => {

    return new Promise(async (resolve, reject) => {

        try {
            const resp = await axios.post(`${BaseURL}login`, form);
            resolve(resp.data)
        } catch (err) {
            reject(err.response)
        }

    })

}

const SignUp = (form) => {

    return new Promise(async (resolve, reject) => {

        try {
            const resp = await axios.post(`${BaseURL}register`, form);
            resolve(resp.data)

        } catch (err) {
            reject(err)
        }

    })

}

const getSchoolPro = () => {
    return new Promise(async (resolve, reject) => {

        try {
            // const token = localStorage.getItem('token')

            const resp = await axios.get(`${BaseURL}school/programs`);
            resolve(resp.data)

        } catch (err) {
            reject(err)
        }

    })
}
const changePassword = (body) => {

    return new Promise(async (resolve, reject) => {

        try {

            const resp = await axios.post(`${BaseURL}changeUserPassword`, body);
            resolve(resp.data)

        } catch (err) {
            reject(err)
        }

    })
}

const completeSchoolInfo = (form) => {
    return new Promise(async (resolve, reject) => {

        try {

            const resp = await axios.patch(`${BaseURL}school/info`, form);
            resolve(resp.data)

        } catch (err) {
            reject(err)
        }

    })
}

const addSubAdmin = (form) => {
    return new Promise(async (resolve, reject) => {

        try {

            const resp = await axios.post(`${BaseURL}add/sub/admin`, form);
            resolve(resp.data)

        } catch (err) {
            reject(err)
        }

    })
}
const editHospiatalSubAdmin = (form) => {
    return new Promise(async (resolve, reject) => {

        try {

            const resp = await axios.patch(`${BaseURL}hospital/manageSubAdminPrivillege`, form);
            resolve(resp.data)

        } catch (err) {
            reject(err)
        }

    })
}
const editSchoolSubAdmin = (form) => {
    return new Promise(async (resolve, reject) => {

        try {

            const resp = await axios.patch(`${BaseURL}school/manageSubAdminPrivillege`, form);
            resolve(resp.data)

        } catch (err) {
            reject(err)
        }

    })
}

const getSubAdminList = (id,type) => {
    return new Promise(async (resolve, reject) => {

        try {

            const resp = await axios.get(`${BaseURL}get/sub/admin?sub_admin_ref_id=${id}&${type}=true`,);
            resolve(resp.data)

        } catch (err) {
            reject(err)
        }

    })
}

const removeOneSubAdmin = (deletedata) => {
    return new Promise(async (resolve, reject) => {

        try {

            const resp = await axios.post(`${BaseURL}remove/sub/admin `, deletedata);
            resolve(resp.data)

        } catch (err) {
            reject(err)
        }

    })
}

const getTestimonal = () => {
    return new Promise(async (resolve, reject) => {

        try {

            const resp = await axios.get(`${BaseURL}users/getTestimonials`);
            resolve(resp.data)

        } catch (err) {
            reject(err)
        }

    })
}



//------------------------------------Student Auth---------------------------------------------//

export const authServices = { login,getTestimonal,editSchoolSubAdmin, editHospiatalSubAdmin,SignUp, getSchoolPro, completeSchoolInfo, changePassword, addSubAdmin, getSubAdminList,removeOneSubAdmin }